import React, { useEffect, useState } from 'react'
import HeaderPage from '../components/homePage/HeaderPage'
import FooterPage from '../components/homePage/FooterPage'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';
import HeaderUser from '../components/homePage/HeaderUser';




function ContactUs() {
  const { userDetailLogin } = useSelector((state) => state.auth);
  const [messageShow, setMessage] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    enquiry_for: "",
    message: ""
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [captcha, setCaptcha] = useState({ a: 0, b: 0 });
  const [captchaAnswer, setCaptchaAnswer] = useState("");

  const refreshCaptcha = () => {
    const a = Math.floor(Math.random() * 9) + 1; // 1..9
    const b = Math.floor(Math.random() * 9) + 1; // 1..9
    setCaptcha({ a, b });
    setCaptchaAnswer("");
    setErrors((prev) => {
      const next = { ...prev };
      delete next.captchaAnswer;
      return next;
    });
  };

  useEffect(() => {
    refreshCaptcha();
  }, []);

  const setFieldError = (name, message) => {
    setErrors((prev) => ({ ...prev, [name]: message }));
  };

  const clearFieldError = (name) => {
    setErrors((prev) => {
      if (!prev[name]) return prev;
      const next = { ...prev };
      delete next[name];
      return next;
    });
  };

  const validateField = (name, value) => {
    const v = String(value ?? "").trim();

    if (name === "name") {
      if (!v) return "Name is required";
      if (v.length < 2) return "Name must be at least 2 characters";
      return "";
    }

    if (name === "email") {
      if (!v) return "Email is required";
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(v)) return "Enter a valid email";
      return "";
    }

    if (name === "mobile") {
      if (!v) return "Mobile number is required";
      if (!/^\d{10}$/.test(v)) return "Enter a valid 10-digit mobile number";
      return "";
    }

    if (name === "enquiry_for") {
      if (!v) return "Enquiry For is required";
      return "";
    }

    if (name === "message") {
      if (!v) return "Message is required";
      if (v.length < 10) return "Message must be at least 10 characters";
      return "";
    }

    if (name === "captchaAnswer") {
      if (!v) return "Captcha answer is required";
      if (!/^\d{1,3}$/.test(v)) return "Enter numbers only";
      return "";
    }

    return "";
  };

  const validateAll = () => {
    const nextErrors = {};
    for (const key of ["name", "email", "mobile", "enquiry_for", "message"]) {
      const msg = validateField(key, formData[key]);
      if (msg) nextErrors[key] = msg;
    }
    const captchaMsg = validateField("captchaAnswer", captchaAnswer);
    if (captchaMsg) nextErrors.captchaAnswer = captchaMsg;

    const expected = Number(captcha.a) + Number(captcha.b);
    const provided = Number(String(captchaAnswer).trim());
    if (!nextErrors.captchaAnswer && provided !== expected) {
      nextErrors.captchaAnswer = "Captcha does not match";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    clearFieldError(name);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const msg = validateField(name, value);
    if (msg) setFieldError(name, msg);
    else clearFieldError(name);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateAll()) return;

    try {
      setIsLoading(true);
      const payload = { ...formData };

      const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/front/contact-us`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      if (!res.ok || !data?.success) {
        setMessage(data?.message || "Enquiry submit failed");
        
        return;
      }

      setMessage(data?.message || "Enquiry submitted");
      setFormData({ name: "", email: "", mobile: "", enquiry_for: "", message: "" });
      setCaptchaAnswer("");
      setErrors({});
      refreshCaptcha();
    } catch (error) {
      console.error(error);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    
    <>
    { userDetailLogin?._id ? <HeaderUser /> : <HeaderPage /> }
    <>
  <section className="inrbnr">
    <div className="container-fluid con-flu-padd">
      <div className="inrbnrContent">
        <h1>Contact Us</h1>
        <ul className="inrbrnNav">
          <li>
            <Link to={userDetailLogin?._id ? '/dashboard':'/'}>
              <img src="assets/img/icons/home.png" alt="home icon" />
            </Link>
            <img src="assets/img/icons/arrows.png" alt="arrows icons" />
          </li>
          <li>
            <Link to="#">Contact Us</Link>
          </li>
        </ul>
      </div>
    </div>
  </section>
  {/* Section End */}
  <section>
    <div className="register-sec">
      <div className="site-width">
        <div className="row pt-5">
          <div className="col-lg-7">
            {/* start */}
            <div className="contactinfoWrapper">
              <div className="contactInfo">
                <div
                  className="titleSection left wow animate__fadeInDown"
                  style={{ visibility: "visible", animationName: "fadeInDown" }}
                >
                  <h4>Contact Us</h4>
                  <h2>Contact Details</h2>
                  {/* <p>
                                      Lorem ipsum dolor sit amet consectetur adipisicing elit. Laudantium maiores at magni!
                                  </p> */}
                  <span className="divider">
                    <img src="assets/img/divider1.png" alt="img" />
                  </span>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="contactInfoCard d-flex align-item-center">
                      <div className="ctinfoCIco">
                        <img src="assets/img/location.svg" alt="ico" />
                      </div>
                      <div className="ctinfoTitle">
                        <h4>VIVASHRI PRIVATE LIMITED</h4>
                        <h6>
                          E - 49/5, First Floor, Okhla Industrial Area Phase I,
                          New Delhi, 110020.
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="contactInfoCard d-flex align-item-center">
                      <div className="ctinfoCIco">
                        <img src="assets/img/call.svg" alt="ico" />
                      </div>
                      <div className="ctinfoTitle">
                        <h4>Call</h4>
                        <h6>
                          <a href="tel:917631110005" target="_blank" rel='noreferrer'>
                            +91 7631110005
                          </a>{" "}
                        </h6>
                      </div>
                    </div>
                  </div>
                  
                  { /* <div className="col-md-6">
                    <div className="contactInfoCard d-flex align-item-center">
                      <div className="ctinfoCIco">
                        <img src="assets/img/email.svg" alt="ico" />
                      </div>
                      <div className="ctinfoTitle">
                        <h4>Email</h4>
                        <h6>
                          <a href="mailto:" target="_blank" rel='noreferrer'>
                            vivashri@gmail.com
                          </a>{" "}
                        </h6>
                      </div>
                    </div>
                  </div> */ }

                </div>
              </div>
              <div className="ourSocials mt-4">
                <h4>Our Social Media</h4>
                <ul className="sociaMediaIcons">
  <li>
    <Link to="https://www.facebook.com/profile.php?id=61580815894015" target="_blank" title="follow us on Facebook">
      <i className="fa-brands fa-facebook-f" />
    </Link>
  </li>
  <li>
    <Link to="https://www.instagram.com/viva.shri" target="_blank" title="follow us on Instagram">
      <i className="fa-brands fa-instagram" />
    </Link>
  </li>
  <li>
    <Link to="https://x.com/VIVA_SHRI" target="_blank" title="follow us on X">
      <i className="fa-brands fa-x-twitter" />
    </Link>
  </li>
  <li>
    <Link to="https://www.linkedin.com/company/vivashri/" target="_blank" title="follow us on Linkedin">
      <i className="fa-brands fa-linkedin-in" />
    </Link>
  </li>
  <li>
    <Link to="https://www.threads.com/@viva.shri" target="_blank" title="follow us on Threads">
      <i className="fa-brands fa-threads" />
    </Link>
  </li>
  <li>
    <Link to="https://youtube.com/@vivashri" target="_blank" title="Like us on Youtube">
      <i className="fa-brands fa-youtube" />
    </Link>
  </li>
</ul>

              </div>
            </div>
            {/* end */}
          </div>
          <div className="col-lg-5">
            <div className="ic-con">
              <h3 className="">Get In Touch</h3>
              <p>Fill the form below to make enquiry</p>
              <div className="col-12">
                <div className="line-bg" style={{ width: "100%" }} />
              </div>
              <form className="row" onSubmit={handleSubmit} noValidate>
                <div className="col-lg-6">
                  <div className="inputs-marg nam-inp mb-0">
                    <label htmlFor="" className="mb-2">
                      Your Name <span style={{ color: "#FF0A0A" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      style={{ width: "100%" }}
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.name && <p className="error">{errors.name}</p>}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputs-marg nam-inp mb-0">
                    <label htmlFor="" className="mb-2">
                      Email <span style={{ color: "#FF0A0A" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      style={{ width: "100%" }}
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.email && <p className="error">{errors.email}</p>}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputs-marg nam-inp mb-0">
                    <label htmlFor="" className="mb-2">
                      Mobile No. <span style={{ color: "#FF0A0A" }}>*</span>
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      style={{ width: "100%" }}
                      name="mobile"
                      value={formData.mobile}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                        setFormData((prev) => ({ ...prev, mobile: value }));
                        clearFieldError("mobile");
                      }}
                      onBlur={handleBlur}
                      maxLength={10}
                      inputMode="numeric"
                    />
                    {errors.mobile && <p className="error">{errors.mobile}</p>}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputs-marg nam-inp mb-0">
                    <label htmlFor="" className="mb-2">
                      Enquiry For <span style={{ color: "#FF0A0A" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      style={{ width: "100%" }}
                      name="enquiry_for"
                      value={formData.enquiry_for}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.enquiry_for && <p className="error">{errors.enquiry_for}</p>}
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="inputs-marg nam-inp mb-0">
                    <label htmlFor="" className="mb-2">
                      Your Message <span style={{ color: "#FF0A0A" }}>*</span>
                    </label>
                    <textarea
                      className="form-control"
                      style={{ width: "100%" }}
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.message && <p className="error">{errors.message}</p>}
                  </div>
                </div>

                <div className="col-lg-12 mt-2">
                  <div className="inputs-marg nam-inp mb-0">
                    <label className="mb-2">
                      Captcha <span style={{ color: "#FF0A0A" }}>*</span>
                    </label>
                    <div className="d-flex gap-2 align-items-center">
                      <input
                        type="text"
                        className="form-control"
                        style={{ width: "100%" }}
                        value={`Solve: ${captcha.a} + ${captcha.b} = ?`}
                        readOnly
                      />
                      <button
                        type="button"
                        
                        style={{  whiteSpace: "nowrap" }}
                        onClick={refreshCaptcha}
                        title="Refresh captcha"
                      >
                        <i className="fa-solid fa-refresh" /><i/>
                      </button>
                    </div>
                    <input
                      type="text"
                      className="form-control mt-2"
                      style={{ width: "100%" }}
                      name="captchaAnswer"
                      placeholder="Enter captcha answer"
                      value={captchaAnswer}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "").slice(0, 3);
                        setCaptchaAnswer(value);
                        clearFieldError("captchaAnswer");
                      }}
                      onBlur={(e) => {
                        const msg = validateField("captchaAnswer", e.target.value);
                        if (msg) setFieldError("captchaAnswer", msg);
                        else clearFieldError("captchaAnswer");
                      }}
                      inputMode="numeric"
                    />
                    {errors.captchaAnswer && <p className="error">{errors.captchaAnswer}</p>}
                  </div>
                </div>
                <div className="nam-inp mt-3 text-end">
                  <button className="countiniue p-0" type="submit" disabled={isLoading}>
                    {isLoading ? "Sending..." : "Send Message"}
                  </button>
                  {messageShow && <p className="text-success mt-2">{messageShow}</p>}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>



    <FooterPage /> 

     
    </>
    
  )
}

export default ContactUs
